export function formatDate(value) {
  if (!value) return '';
  try {
    return new Date(value).toLocaleDateString(undefined, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return String(value);
  }
}

export function formatDateTime(value) {
  if (!value) return '';
  try {
    return new Date(value).toLocaleString();
  } catch {
    return String(value);
  }
}

export function formatRelativeCount(count, singular, plural) {
  const n = count ?? 0;
  return `${n} ${n === 1 ? singular : plural || `${singular}s`}`;
}
